import React from 'react';
import MessageA23 from './MessageA23';



const MessageA42 = (props) => {


  
    let data =props.item && props.item.text_data && props.item.text_data.html 
    // data = data.replace('<a','<div')
    // data = data.replace('</a>','</div>')
    // console.log("whatsappprops",props,data)



    return(
    
        <div  style={{ margin: '10px 0px' }} dangerouslySetInnerHTML={{__html: data }}></div>
    )


}

export default MessageA42;